import { TableColumn } from "../../models/tables/TableColumn";
import { COLUMN_TYPES } from "../COLUMN_TYPES";

export const BookKeeperTripHistoryColumns: TableColumn[] = [
    {
        name: "billOfLading", 
        displayName: "BL No.", 
        dataType: COLUMN_TYPES.string, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {},
        reference: '',
        selectOptions: null
    },
    {
        name: "containerNumber", 
        displayName: "Container No.", 
        dataType: COLUMN_TYPES.string, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {},
        reference: '',
        selectOptions: null
    },
    {
        name: "containerSize", 
        displayName: "Size", 
        dataType: COLUMN_TYPES.string, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {},
        reference: '',
        selectOptions: null
    },
    {
        name: "bookKeeper", 
        displayName: "Book Keeper", 
        dataType: COLUMN_TYPES.string, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {},
        reference: '',
        selectOptions: null
    },
    {
        name: "driver", 
        displayName: "Driver", 
        dataType: COLUMN_TYPES.string, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {},
        reference: '',
        selectOptions: null
    },
    {
        name: "driverRate", 
        displayName: "Driver Rate", 
        dataType: COLUMN_TYPES.currency, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {},
        reference: '',
        selectOptions: null
    },
    {
        name: "helper", 
        displayName: "Helper", 
        dataType: COLUMN_TYPES.string, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {},
        reference: '',
        selectOptions: null
    },
    {
        name: "helperRate", 
        displayName: "Helper Rate", 
        dataType: COLUMN_TYPES.currency, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {},
        reference: '',
        selectOptions: null
    }
];


// WEBPACK FOOTER //
// ./src/app/contants/columns/columns.profile.bookKeeper.trip.history.ts